var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditProfileSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 21V19C6 17.9391 6.42143 16.9217 7.17157 16.1716C7.92172 15.4214 8.93913 15 10 15H13.5M8 7C8 8.06087 8.42143 9.07828 9.17157 9.82843C9.92172 10.5786 10.9391 11 12 11C13.0609 11 14.0783 10.5786 14.8284 9.82843C15.5786 9.07828 16 8.06087 16 7C16 5.93913 15.5786 4.92172 14.8284 4.17157C14.0783 3.42143 13.0609 3 12 3C10.9391 3 9.92172 3.42143 9.17157 4.17157C8.42143 4.92172 8 5.93913 8 7ZM18.42 15.61C18.615 15.415 18.8465 15.2603 19.1013 15.1547C19.3561 15.0492 19.6292 14.9949 19.905 14.9949C20.1808 14.9949 20.4539 15.0492 20.7087 15.1547C20.9635 15.2603 21.195 15.415 21.39 15.61C21.585 15.805 21.7397 16.0365 21.8452 16.2913C21.9508 16.5461 22.0051 16.8192 22.0051 17.095C22.0051 17.3708 21.9508 17.6439 21.8452 17.8987C21.7397 18.1535 21.585 18.385 21.39 18.58L18 22H15V19L18.42 15.61Z",
    stroke: "#00332D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditProfileSelected);
export default __webpack_public_path__ + "static/media/editProfileSelected.79257cb390450f11db2324a9caf59a6d.svg";
export { ForwardRef as ReactComponent };